import { useState, useEffect } from 'react';
import { Layout as AntLayout, Menu, Button, Dropdown, Space, Avatar } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    PayCircleOutlined,
    TeamOutlined,
    ShopOutlined,
    TransactionOutlined,
    MenuOutlined,
    UserOutlined,
    LogoutOutlined
} from '@ant-design/icons';
import '../styles/Layout.css';
import logo from '../assets/img/logo.svg';

const { Header, Sider, Content } = AntLayout;

const Layout = ({ children, currentUser }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [collapsed, setCollapsed] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);


    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
    };

    const handleLogoClick = () => {
        navigate('/');
    };

    const handleLogout = () => {
        // Logout logikasi
        console.log('Logout clicked');
        localStorage.removeItem('accessToken');
        window.location.reload();
    };

    const userMenu = {
        items: [
            {
                key: 'logout',
                icon: <LogoutOutlined />,
                label: 'Chiqish',
                onClick: handleLogout
            }
        ]
    };

    const menuItems = [
        { key: '/', icon: <TeamOutlined />, label: 'Partnerlar' },
        { key: '/merchants', icon: <ShopOutlined />, label: 'Merchantlar' },
        { key: '/bank-accounts', icon: <ShopOutlined />, label: 'Bank Hisob raqamlar' },
        { key: '/terminals', icon: <ShopOutlined />, label: 'Terminallar' },
        { key: '/static-qr', icon: <TransactionOutlined />, label: 'Static QRlar' },
        { key: '/transactions-qr', icon: <TransactionOutlined />, label: 'Dinamik Qrlar' },
        { key: '/mcc-codes', icon: <ShopOutlined />, label: 'Mcc kodlar' },
        { key: '/transactions', icon: <PayCircleOutlined />, label: 'Tranzaksiyalar' },
    ];

    return (
        <AntLayout style={{ minHeight: '100vh' }}>
            <Sider
                className={'sticky-sider'}
                collapsible
                collapsed={collapsed}
                onCollapse={toggleCollapsed}
                breakpoint="lg"
                collapsedWidth={0}
                width={250}
            >
                <div className="logo-container" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
                    <img src={logo} alt="Logo" className="logo" />
                </div>
                <Menu
                    theme="dark"
                    mode="inline"
                    items={menuItems}
                    onClick={({ key }) => navigate(key)}
                    selectedKeys={[location.pathname]}
                />
            </Sider>
            <AntLayout>
                <Header className="header" style={{ display: 'flex', justifyContent: 'space-between', padding: '0 24px' }}>
                    <div>
                        {(isMobile || collapsed) && (
                            <Button
                                type="primary"
                                icon={<MenuOutlined />}
                                onClick={toggleCollapsed}
                            />
                        )}
                        {/*{isMobile && (*/}
                        {/*    <Button*/}
                        {/*        type="primary"*/}
                        {/*        icon={<MenuOutlined />}*/}
                        {/*        onClick={toggleCollapsed}*/}
                        {/*    />*/}
                        {/*)}*/}
                    </div>

                    <Dropdown menu={userMenu} placement="bottomRight">
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            marginRight: '16px'  // O'ng tarafdan uzaytirish uchun
                        }}>
                            <div style={{ marginRight: '8px', textAlign: 'right' }}>
                                <div style={{fontWeight: 'bold', lineHeight: '1.2' }}>{currentUser?.fullname}</div>
                                <div style={{fontSize: '12px', lineHeight: '1.2' }}>{currentUser?.phone}</div>
                            </div>
                            <Avatar
                                icon={<UserOutlined />}
                                style={{ backgroundColor: '#1890ff' }}
                            />
                        </div>
                    </Dropdown>
                </Header>
                <Content className="content">{children}</Content>
            </AntLayout>
        </AntLayout>
    );
};

export default Layout;